<template>
  <div>
    <span v-if="!(call.recording && call.recordingDownloaded)" class="text-muted small">{{ $t('arNoRecording') }}</span>
    <b-button v-else-if="!open" size="sm" variant="outline-primary" @click="listen"><i class="fa fa-play"></i> {{ $t('arListen') }}</b-button>
    <span v-else-if="glacier" class="badge badge-info">{{ $t('arGlacier') }}</span>
    <span v-else-if="failed" class="text-danger small">{{ failed }}</span>
    <app-audio v-else :id="call.call" :duration="call.billDuration"></app-audio>
  </div>
</template>

<script>
// KT-33900 — ô ghi âm trong hồ sơ: bấm Nghe → ghi vết (ai nghe cuộc nào) + kiểm kho lạnh → mới hiện player
import AppAudio from '@/components/AppAudio';
import arI18n from './authority-request-i18n';

export default {
  props: ['call', 'requestId'],
  components: {AppAudio},
  i18n: arI18n,
  data() { return {open: false, glacier: false, failed: ''}; },
  methods: {
    // GET /recording ghi vết (ai nghe cuộc nào) + kiểm kho lạnh; lỗi → không mở player (nghe phải có vết)
    async listen() {
      this.failed = '';
      try {
        const r = await this.$service.get(`/authority-request/${this.requestId}/recording/${this.call.call}`);
        this.glacier = !(r.data && r.data.success);
        this.open = true;
      } catch (e) {
        this.failed = (e.response && e.response.data && e.response.data.message) || this.$t('arError');
        this.open = true;
      }
    },
  },
};
</script>
